import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dialog, Card, CardContent, Button } from '@material-ui/core'
import { doPanic } from '../../actions/users'

class PanicModal extends Component {
  state = {
    val: 10,
    interval: null
  }
  componentDidUpdate(p) {
    if (this.props.open && !p.open) {
      this.setState({
        interval: setInterval(() => {
          if (this.state.val - 1 >= 0) {
            this.setState({ val: this.state.val - 1 })
          } else {
            clearInterval(this.state.interval)
          }
        }, 1000),
        val: 10
      })
    }

    if (this.state.val === 0) {
        this.props.dispatch(doPanic())
    }

    if (p.open && !this.props.open) {
      clearInterval(this.state.interval)
      this.setState({ val: 10 })
    }
  }

  render() {
    return (
      <Dialog open={this.props.open}>
        <Card>
          <CardContent>
            <h3 style={{ margin: 0 }}>You clicked the emergency button</h3>
          </CardContent>
          <CardContent>
            When the timer below expires we will contact your emergency contact
            list
          </CardContent>
          {this.state.val === 0 ? (
            <h3 style={{ margin: 0, color: '#5e5e5e', textAlign: 'center' }}>
              Emergency Contacts Notified
            </h3>
          ) : (
            <h1
              style={{
                margin: 0,
                textAlign: 'center',
                fontSize: '32px',
                color: '#5e5e5e'
              }}
            >
              {this.state.val}
            </h1>
          )}
          <CardContent>
            <div style={{ display: 'flex' }}>
              <Button color="primary" variant="text" href="tel:911">
                Dial 911
              </Button>
              <div style={{ flexGrow: 1 }} />
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.props.dispatch({ type: 'PANIC_SNACKBAR' })}
              >
                {this.state.val === 0 ? 'Close' : 'Cancel'}
              </Button>
            </div>
          </CardContent>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.panic
  }
}

const connector = connect(mapStateToProps)

export default connector(PanicModal)
